export default {
  // Common
  app: {
    name: 'Coloursense',
    tagline: 'Scopri i Tuoi Colori Perfetti',
  },
  common: {
    back: 'Indietro',
    cancel: 'Annulla',
    save: 'Salva',
    share: 'Condividi',
    create: 'Crea',
    delete: 'Elimina',
    edit: 'Modifica',
    loading: 'Caricamento...',
    error: 'Si è verificato un errore',
    success: 'Successo!',
    tryAgain: 'Riprova',
    reset: 'Reimposta',
  },
  accessibility: {
    title: 'Impostazioni di Accessibilità',
    visualTitle: 'Impostazioni Visive',
    audioTitle: 'Impostazioni Audio',
    colorBlindMode: 'Modalità Daltonismo',
    colorBlindModeDesc:
      'Regola i colori per renderli più distinguibili per gli utenti daltonici',
    colorBlindType: 'Tipo di Daltonismo',
    protanopia: 'Protanopia (Cieco al Rosso)',
    deuteranopia: 'Deuteranopia (Cieco al Verde)',
    tritanopia: 'Tritanopia (Cieco al Blu)',
    achromatopsia: 'Acromatopsia (Senza Colori)',
    highContrast: 'Alto Contrasto',
    highContrastDesc: 'Aumenta il contrasto tra testo e sfondo',
    largeText: 'Testo Grande',
    largeTextDesc: "Aumenta la dimensione del testo in tutta l'app",
    voiceGuidance: 'Guida Vocale',
    voiceGuidanceDesc:
      "Abilita feedback vocale per la navigazione e l'analisi dei colori",
    showColorNames: 'Mostra Nomi dei Colori',
    showColorNamesDesc:
      'Mostra sempre i nomi dei colori accanto ai campioni di colore',
    resetSettings: 'Reimposta Impostazioni di Accessibilità',
    resetTitle: 'Reimposta Impostazioni',
    resetConfirm:
      'Sei sicuro di voler reimpostare tutte le impostazioni di accessibilità ai valori predefiniti?',
  },

  // Auth
  auth: {
    login: 'Accedi',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Password dimenticata?',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    logout: 'Esci',
  },

  // Home Screen
  home: {
    features: 'Funzionalità',
    startAnalysis: 'Inizia Analisi Colore',
    comingSoon: 'Prossimamente',
  },

  // Color Analysis
  colorAnalysis: {
    title: 'Analisi Colore',
    upload: 'Carica Foto',
    takePhoto: 'Scatta Foto',
    analyzing: 'Analisi dei tuoi colori in corso...',
    results: 'Risultati Analisi',
    yourPalette: 'La Tua Palette di Colori',
  },

  // Virtual Drape Test
  drapeTest: {
    title: 'Test Virtuale Colori',
    subtitle: 'Prova Colori Sul Tuo Viso',
    uploadSelfie:
      'Carica un selfie e confronta come appaiono diversi colori accanto al tuo viso',
    chooseGallery: 'Scegli dalla Galleria',
    takeSelfie: 'Scatta Selfie',
    changeImage: 'Cambia Immagine',
    colorPalettes: 'Palette di Colori',
    tapColor: 'Tocca un colore per vedere come appare accanto al tuo viso',
    analysis: 'Analisi Colore',
    howWorks: 'Come funziona questo colore per te:',
    selectColor: 'Seleziona un colore sopra per vedere feedback personalizzati',
    createCard: 'Crea Scheda Condivisibile',
  },

  // Smart Wardrobe
  wardrobe: {
    title: 'Guardaroba Intelligente',
    yourPalette: 'La Tua Palette di Colori',
    yourItems: 'I Tuoi Capi di Abbigliamento',
    addItem: '+ Aggiungi Capo',
    addNew: 'Aggiungi Nuovo Capo',
    uploadPhoto: 'Carica foto del capo',
    itemName: 'Nome Articolo',
    tags: 'Tag (separati da virgole)',
    addToWardrobe: 'Aggiungi al Guardaroba',
    paletteMatch: 'Corrispondenza con Palette:',
  },

  // Wear This Today
  outfits: {
    title: 'Cosa Indossare Oggi',
    weather: 'Meteo di Oggi',
    humidity: 'Umidità',
    wind: 'Vento',
    recommended: 'Outfit Consigliato per Oggi',
    generating: 'Generazione outfit perfetto...',
    generateAnother: 'Genera un Altro Outfit',
    whyChosen: 'Perché Abbiamo Scelto Questo',
  },

  // Premium Features
  premium: {
    title: 'Sblocca Funzionalità Premium',
    subtitle:
      'Passa a Coloursense Premium per accesso completo a tutte le funzionalità',
    smartWardrobe: 'Guardaroba Intelligente',
    wardrobeDesc:
      'Etichetta i tuoi vestiti e scopri cosa si adatta alla tua palette di colori',
    wearToday: 'Cosa Indossare Oggi',
    wearTodayDesc:
      'Ottieni suggerimenti di outfit basati sul meteo e sui tuoi colori',
    unlimited: 'Analisi Illimitate',
    unlimitedDesc:
      'Crea profili di colore illimitati e salva la cronologia delle analisi',
    noAds: 'Nessuna Pubblicità',
    noAdsDesc: "Goditi un'esperienza senza pubblicità in tutta l'app",
    monthly: 'Mensile',
    yearly: 'Annuale',
    save: 'Risparmia 30%',
    perMonth: 'al mese',
    perYear: "all'anno",
    upgradeButton: 'Passa a Premium',
    processing: 'Elaborazione in corso...',
    restore: 'Ripristina Acquisti',
    terms:
      "Il pagamento verrà addebitato sul tuo account Apple ID alla conferma dell'acquisto. L'abbonamento si rinnova automaticamente a meno che non venga annullato almeno 24 ore prima della fine del periodo corrente. Il tuo account verrà addebitato per il rinnovo entro 24 ore prima della fine del periodo corrente. Puoi gestire e annullare i tuoi abbonamenti andando alle impostazioni del tuo account su App Store dopo l'acquisto.",
  },

  // Subscription Context
  subscription: {
    freePlan: 'Piano Gratuito',
    premiumPlan: 'Piano Premium',
    upgradeSuccess: 'Aggiornamento a Premium riuscito!',
    upgradeError: 'Impossibile aggiornare a Premium',
    restoreSuccess: 'Acquisti ripristinati con successo!',
    restoreError: 'Impossibile ripristinare gli acquisti',
    premiumRequired: 'Premium Richiesto',
    premiumFeature: 'Questa è una funzionalità premium',
    upgradeToAccess: 'Passa a Premium per accedere a questa funzionalità',
    goToPremium: 'Vai a Premium',
    continueFree: 'Continua con Gratuito',
  },

  // Shareable Cards
  shareableCard: {
    title: 'La Tua Scheda Colore',
    cannotCreate: 'Impossibile Creare Scheda',
    selectImageColor: "Seleziona prima un'immagine e un colore.",
    saved: 'Scheda salvata nelle tue foto!',
    shareTitle: 'Condividi La Tua Scheda Colore',
    notAvailable: 'Condivisione non disponibile',
    notAvailableDesc: 'La condivisione non è disponibile sul tuo dispositivo',
    error: 'Impossibile condividere la tua scheda colore.',
    myAnalysis: 'La Mia Analisi Colore',
    createdWith: 'Creato con Coloursense',
  },

  // Lighting Conditions
  lighting: {
    title: 'Condizioni di Illuminazione',
    standard: {
      name: 'Standard',
      description:
        'Illuminazione interna bilanciata, adatta per la maggior parte degli ambienti',
    },
    tropical: {
      name: 'Tropicale',
      description: 'Luce solare brillante e calda ad alta intensità',
    },
    nordic: {
      name: 'Nordica',
      description:
        'Luce naturale fredda con tinta bluastra comune nelle regioni settentrionali',
    },
    office: {
      name: 'Ufficio',
      description: "Illuminazione fluorescente tipica degli ambienti d'ufficio",
    },
    evening: {
      name: 'Serale',
      description:
        'Illuminazione calda e dorata durante il tramonto o con lampade interne',
    },
    selectLighting: 'Seleziona Condizione di Illuminazione',
    adjustPalette: 'Regola la palette per diverse illuminazioni',
  },
};
